import { ApprovalStatusButton } from "components"
import { InfoItemVertical } from "components2"
import { useFormikContext } from "formik"
import htmlParser from 'html-react-parser'
import { Fragment } from "react"
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap"
import { dateConvert } from "utilities2"
import { ApprovalStatusConst } from "../const/ApprovalStatusConst"

export const DetailPermintaanPerubahanData = () => {
  const { values } = useFormikContext()

  return (
    <Fragment>
      <Row>
        <Col>
          <InfoItemVertical
            label="Tgl. Permintaan Pengubahan Data"
            text={dateConvert().getSlashDMY(new Date(values?.tgl_permintaan_perubahan_data_master))}
          />
        </Col>

        <Col>
          <InfoItemVertical
            label="No. Permintaan Pengubahan Data"
            text={values.no_permintaan_perubahan_data_master}
          />
        </Col>

        <Col>
          <InfoItemVertical label="Urgensi" text={values.urgensi} />
        </Col>

        <Col>
          <InfoItemVertical label="Status" text={
            <OverlayTrigger
              placement="top"
              delay={{ show: 500, hide: 500 }}
              trigger={["hover", "focus", "click"]}
              overlay={
                <Tooltip id={"tooltip-status"}>
                  {ApprovalStatusConst[values.status]?.tooltip}
                </Tooltip>
              }
            >
              <span className="d-inline-block">
                <ApprovalStatusButton
                  variant={ApprovalStatusConst[values?.status]?.variant}
                  children={ApprovalStatusConst[values?.status]?.label}
                />
              </span>
            </OverlayTrigger>


          } />
        </Col>
      </Row>

      <InfoItemVertical label="Deskripsi" text={values?.deskripsi?.length ? htmlParser(values.deskripsi) : "-"} />
    </Fragment>
  )
}